import registerLink from '../../../common/links/index';

import presentationalComponent from './Link';
import containerComponent from './LinkContainer';

import { TOOLBAR_TOOLS, TOOL_SETS } from '../../workspace/toolbar/config/toolbarToolConfig';
import { allSelectedElementsDisplayingInfo } from '../../workspace/toolbar/config/toolbarToolConfigUtils';

const allDisplayingInfo = ({ selectedElements }) => allSelectedElementsDisplayingInfo(selectedElements);

const linkSelectedToolsBeforeCaption = [
    TOOLBAR_TOOLS.COLOR,
    TOOLBAR_TOOLS.LABEL,
    TOOLBAR_TOOLS.REACTION,
    TOOLBAR_TOOLS.COMMENT,
    { ...TOOLBAR_TOOLS.MEDIA, availabilityPredicate: allDisplayingInfo },
    TOOLBAR_TOOLS.DISPLAY_INFO,
];

const LINK_CORE_SELECTED_TOOLS = [
    ...linkSelectedToolsBeforeCaption,
    { ...TOOLBAR_TOOLS.CAPTION, availabilityPredicate: allDisplayingInfo },
];

const LINK_SELECTED_TOOLS = [
    ...linkSelectedToolsBeforeCaption,
    { ...TOOLBAR_TOOLS.RENAME, availabilityPredicate: allDisplayingInfo },
    { ...TOOLBAR_TOOLS.CAPTION, availabilityPredicate: allDisplayingInfo },
    ...TOOL_SETS.MULTI_SELECT_ARRANGEMENT,
    ...TOOL_SETS.TRAILING_SELECTED,
];

export default () =>
    registerLink({
        containerComponent,
        presentationalComponent,
        tools: {
            selected: LINK_SELECTED_TOOLS,
            editing_TITLE: [...LINK_CORE_SELECTED_TOOLS, ...TOOL_SETS.MULTI_SELECT_ARRANGEMENT],
            editing_CAPTION: TOOL_SETS.TEXT_EDITING_CAPTION,
        },
    });
